import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const Content = styled.div`
    flex-direction: column;
    gap: 10px;
    width: 100%;
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        gap: 16px;
    }
`;

export const ListWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 168px;
    gap: 8px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-rows: 128px;
        gap: 0;
    }
`;
